import type {
  ExerciseResponse,
  ExerciseTypeResponse,
  MusclesResponse,
  MuscleGroupsResponse,
  EquipmentResponse,
  Equipment,
  MuscleGroup,
} from "types/apiResponses";
import type { MostPlayedItem, MostPlayedRange } from "types/mostPlayed";
import config from "../config/config";
import axios from "../util/axios";

export async function getMostPlayedExercises(
  range: MostPlayedRange,
): Promise<MostPlayedItem[]> {
  const result = await axios.get(
    `${config.defaults.api_url}/exercises/most-played`,
    { params: { range } },
  );
  return result.data.results;
}

export async function getExerciseDetails(id: any): Promise<ExerciseResponse> {
  return (await axios.get(`${config.defaults.api_url}/exercises/${id}`)).data;
}

export async function updateExercise(params: any, id: any) {
  return axios.post(`${config.defaults.api_url}/exercises/${id}`, params);
}

export async function deleteExercise(id: any) {
  return axios.delete(`${config.defaults.api_url}/exercises/delete/${id}`);
}

export async function createExercise(params: any) {
  return axios.post(`${config.defaults.api_url}/exercises/create`, params);
}

export async function getAllExerciseTypes(): Promise<ExerciseTypeResponse> {
  const response = await axios.get(`${config.defaults.api_url}/exercises/type`);
  return response.data;
}

export async function getAllMuscles(): Promise<MusclesResponse> {
  const response = await axios.get(
    `${config.defaults.api_url}/exercises/muscles`,
  );
  return response.data;
}

export async function getAllMuscleGroups(): Promise<MuscleGroupsResponse> {
  const response = await axios.get(
    `${config.defaults.api_url}/exercises/muscle-groups`,
  );
  return response.data;
}

export async function searchMuscleGroups(
  searchTerm: string,
): Promise<MuscleGroup[]> {
  try {
    // Since the API doesn't support search for muscle groups,
    // we'll get all muscle groups and filter on the frontend
    const response = await getAllMuscleGroups();
    const allMuscleGroups = response.results;

    if (!searchTerm) {
      return allMuscleGroups;
    }

    return allMuscleGroups.filter((mg: MuscleGroup) =>
      mg.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  } catch (error) {
    console.error("Error searching muscle groups:", error);
    return [];
  }
}

export async function getAllEquipment(): Promise<Equipment[]> {
  const response = await axios.get(
    `${config.defaults.api_url}/exercises/equipment`,
  );
  return (response.data as EquipmentResponse).results;
}

export async function searchEquipment(
  searchTerm: string,
): Promise<Equipment[]> {
  const response = await axios.get(
    `${config.defaults.api_url}/exercises/equipment?search=${searchTerm}`,
  );
  return (response.data as EquipmentResponse).results;
}
